import styled from "styled-components";

export const AboutUsComp = styled.div`
    display: flex;
    padding-top: 7rem;
    padding-bottom: 3rem;
    flex-direction: column;
    @media (max-width: 1000px) {
        margin: 5% 2%;
        padding-bottom: 2rem;
    }
`;

export const AboutUsContent = styled.div`
    display: flex;
    width: 100%;
    padding: 0 16px;
    flex-direction: row;
    justify-content: space-evenly;
    @media (max-width: 1000px) {
        flex-direction: column;
        justify-content: center;
    }
`;

export const TextContent = styled.div`
    color: var(--purple-bhbusmidia);
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: left;
    margin: 0% 5%;
    width: 50%;
    @media (max-width: 1000px) {
        width: 100%;
        margin: 5% 0%;
    }
`;

export const Vantagens = styled.div`
    border-radius: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    justify-content: space-evenly;
    padding: 0.5rem;
    width: 200px;
    background-color: #f5bb12;
    p {
        color: black;
        font-weight: bold;
    }
`;

export const DivContent = styled.div`
    color: var(--purple-bhbusmidia);
    text-align: center;
    margin: 0% 5%;
    width: 50%;
    @media (max-width: 1000px) {
        width: 100%;
        margin: 5% 0%;
    }
`;

export const TextDiv = styled.div`
    border: 3px solid #e5b930;
    padding: 3rem;
    border-radius: 2rem;
    margin-bottom: 2rem;
    p  {
        color: #15191a;
    }
`;

export const TextTitle = styled.div`
    color: #15191a;
    margin-top: 4rem;
    h1 {
        font-family: 'Montserrat', sans-serif;
        font-size: 2.8rem;
        line-height: 1.1;
        color: #15191a;
        text-align: left;
        @media (max-width: 1000px) {
            text-align: center;
        }
    }
    h2 {
        font-family: 'Montserrat', sans-serif;
        font-weight: normal;
        font-size: 1rem;
        margin-top: 20px;
        text-align: left;
        @media (max-width: 1000px) {
            text-align: center;
        }
    }
`;

export const TextBody = styled.div`
    font-size: 24px;
    color: var(--purple-bhbusmidia);
    p {
        color: var(--purple-bhbusmidia);
        margin-top: 3%;
    }
`;

export const VideoContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5%;
`;

export const NavMenu = styled.div`
    display: flex;
    text-align: center;
    align-items: center;
    font-size: 16px;
    margin: 0% 2%;
    color: var(--purple);
    font-weight: bold;
`;

export const NavUl = styled.ul``;

export const NavList = styled.p`
    padding: 5px;
`;


export const SearchDiv = styled.div``;

export const OrcamentoButton = styled.a`
  background: var(--orange);
  border-radius: 100px;
  color: #fff;
  padding: 1rem;
  text-align: center;
  justify-content: center;
  width: 250px;
  display: flex;
  margin-top: 1rem;

  &:hover {
    opacity: 0.9;
  }
`;